import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$enableDuplicateSaleProtection',
  initialState,
  reducers: {
    setEnableDuplicateSaleProtection(state, action: PayloadAction<boolean>) {
      return Boolean(action.payload);
    },
  },
});

export const { setEnableDuplicateSaleProtection } = slice.actions;
export default slice.reducer;
